var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-text-vertical container mx-auto gap-8 tablet:gap-6",class:[_vm.mapClasses()]},[_vm._t("imageText")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }